import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

export const startOneGate = async () => {
  try {
    await bootstrapApplication(AppComponent, appConfig);

    import('@thiememeulenhoff/albert');
    registerLocaleData(localeNl, 'nl');
    registerLocaleData(localeEn, 'en');
  } catch (err) {
    console.error(err);
  }
};

startOneGate();
